// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__Eh-Hk","logo":"MainNavigation_logo__C-+P2","active":"MainNavigation_active__cFvGr","badge":"MainNavigation_badge__UEN7Y"};